import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import AuthGuard from "@/components/feature/AuthGuard";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/login/page";
import Register from "@/pages/register/page";
import Home from "@/pages/home/page";
import Market from "@/pages/market/page";
import LockPrice from "@/pages/lock-price/page";
import Orders from "@/pages/orders/page";
import Perform from "@/pages/orders/perform/page";
import Storage from "@/pages/orders/storage/page";
import StorageRecords from "@/pages/orders/storage/records/page";
import Performance from "@/pages/performance/page";
import Payment from "@/pages/payment/page";
import Profile from "@/pages/profile/page";
import Verify from "@/pages/profile/verify/page";
import Vault from "@/pages/profile/vault/page";
import Address from "@/pages/profile/address/page";
import Bank from "@/pages/profile/bank/page";
import Messages from "@/pages/profile/messages/page";
import Help from "@/pages/profile/help/page";
import Settings from "@/pages/profile/settings/page";
import Withdraw from "@/pages/profile/withdraw/page";
import MaterialWithdraw from "@/pages/profile/withdraw/material/page";
import UsdtWithdraw from "@/pages/profile/withdraw/usdt/page";
import Pickup from "@/pages/profile/pickup/page";
import PickupRecords from "@/pages/profile/pickup/records/page";
import Transactions from "@/pages/profile/transactions/page";
import AdminGuard from "@/pages/admin/components/AdminGuard";
import AdminLayout from "@/pages/admin/components/AdminLayout";
import AdminLogin from "@/pages/admin/login/page";
import AdminDashboard from "@/pages/admin/dashboard/page";
import AdminUsers from "@/pages/admin/users/page";
import AdminOrders from "@/pages/admin/orders/page";
import AdminNotices from "@/pages/admin/notices/page";
import AdminDeposits from "@/pages/admin/deposits/page";
import AdminChannels from "@/pages/admin/channels/page";
import AdminWithdrawals from "@/pages/admin/withdrawals/page";
import AdminPickups from "@/pages/admin/pickups/page";
import AdminSchedule from "@/pages/admin/schedule/page";
import AdminSettings from "@/pages/admin/settings/page";
import Deposit from "@/pages/deposit/page";
import UsdtDeposit from "@/pages/deposit/usdt/page";
import MaterialDeposit from "@/pages/deposit/material/page";
import PrivacyPolicy from "@/pages/privacy/page";
import TermsOfService from "@/pages/terms/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <TermsOfService />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    element: <AuthGuard />,
    children: [
      {
        path: "/home",
        element: <Home />,
      },
      {
        path: "/market",
        element: <Market />,
      },
      {
        path: "/lock-price",
        element: <LockPrice />,
      },
      {
        path: "/orders",
        element: <Orders />,
      },
      {
        path: "/orders/perform",
        element: <Perform />,
      },
      {
        path: "/orders/storage",
        element: <Storage />,
      },
      {
        path: "/orders/storage/records",
        element: <StorageRecords />,
      },
      {
        path: "/performance",
        element: <Performance />,
      },
      {
        path: "/payment",
        element: <Payment />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/profile/verify",
        element: <Verify />,
      },
      {
        path: "/profile/vault",
        element: <Vault />,
      },
      {
        path: "/profile/address",
        element: <Address />,
      },
      {
        path: "/profile/bank",
        element: <Bank />,
      },
      {
        path: "/profile/messages",
        element: <Messages />,
      },
      {
        path: "/profile/help",
        element: <Help />,
      },
      {
        path: "/profile/withdraw",
        element: <Withdraw />,
      },
      {
        path: "/profile/withdraw/material",
        element: <MaterialWithdraw />,
      },
      {
        path: "/profile/withdraw/usdt",
        element: <UsdtWithdraw />,
      },
      {
        path: "/profile/pickup",
        element: <Pickup />,
      },
      {
        path: "/profile/pickup/records",
        element: <PickupRecords />,
      },
      {
        path: "/profile/settings",
        element: <Settings />,
      },
      {
        path: "/profile/transactions",
        element: <Transactions />,
      },
      {
        path: "/deposit",
        element: <Deposit />,
      },
      {
        path: "/deposit/usdt",
        element: <UsdtDeposit />,
      },
      {
        path: "/deposit/material",
        element: <MaterialDeposit />,
      },
    ],
  },
  {
    path: "/admin",
    element: <AdminGuard />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="/admin/dashboard" replace /> },
          { path: "dashboard", element: <AdminDashboard /> },
          { path: "users", element: <AdminUsers /> },
          { path: "orders", element: <AdminOrders /> },
          { path: "notices", element: <AdminNotices /> },
          { path: "deposits", element: <AdminDeposits /> },
          { path: "channels", element: <AdminChannels /> },
          { path: "withdrawals", element: <AdminWithdrawals /> },
          { path: "pickups", element: <AdminPickups /> },
          { path: "schedule", element: <AdminSchedule /> },
          { path: "settings", element: <AdminSettings /> },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;